import imagesSaga from './imagesSaga';

export default imagesSaga;